import { render, staticRenderFns } from "./AccountTerminologyView.vue?vue&type=template&id=6b7f3c4e"
import script from "./AccountTerminologyView.vue?vue&type=script&lang=js"
export * from "./AccountTerminologyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports